import React from "react";

/**
 * Reusable navigation bar for public-facing pages
 */
const PublicNavBar: React.FC = () => {
  return (
    <div className="w-full sticky top-0 z-50 bg-black text-white py-4 shadow-md">
      <div className="container flex items-center justify-between">
        <div className="flex items-center">
          <a href="https://www.hirelo.io/" className="text-2xl font-archivo">
            Hirelo
          </a>
        </div>
        <div className="hidden md:flex items-center space-x-6">
          <a
            href="https://www.hirelo.io/"
            className="hover:text-secondary transition-colors"
          >
            Home
          </a>
          <a
            href="https://www.hirelo.io/#product"
            className="hover:text-secondary transition-colors"
          >
            Product
          </a>
          <a
            href="https://www.hirelo.io/#pricing"
            className="hover:text-secondary transition-colors"
          >
            Pricing
          </a>
          <a
            href="https://www.hirelo.io/#contact"
            className="hover:text-secondary transition-colors"
          >
            Contact
          </a>
          <a
            href="https://www.hirelo.io/#partners"
            className="hover:text-secondary transition-colors"
          >
            Partners & Heroes
          </a>
          <a
            href="https://www.hirelo.io/blog"
            className="hover:text-secondary transition-colors"
          >
            Blog
          </a>
        </div>
        <div>
          <a
            href="https://www.hirelo.io/demo"
            className="hidden md:inline-block px-6 py-2 rounded-full bg-secondary text-secondary-foreground hover:bg-opacity-90 transition-colors"
          >
            Try it out
          </a>
          <a
            href="https://www.hirelo.io/"
            className="md:ml-4 px-6 py-2 rounded-full bg-black text-white border border-white hover:bg-white hover:text-black transition-colors"
          >
            Sign in
          </a>
        </div>
      </div>
    </div>
  );
};

export default PublicNavBar;
